import {useMutation, useQueryClient} from "@tanstack/react-query";
import {uploadProductCurrencyExcelIn} from "../../../../../api/product/ProductInApi";
import {useModal} from "../../../../../hooks";
import {AxiosError} from "axios";


export const useUploadProductCurrencyExcelIn = () => {
    const {handleModal} = useModal();
    const qc = useQueryClient()

    const {mutate} = useMutation({
        mutationFn: (data: FormData) => uploadProductCurrencyExcelIn(data),
        onSuccess: (res) => {
            const data = res.data

            if (data.code === "0000") {
                handleModal({
                    isOpen: true,
                    contents: data.msg,
                    type: 'alert',
                    closeAction: () => {
                        qc.invalidateQueries({queryKey: ["readProductIn"]})
                    }
                })
            } else {
                handleModal({
                    isOpen: true,
                    contents: data.msg,
                    type: 'alert'
                })
            }
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate};
};
